import { ReactNode } from 'react'
import { Ondemand } from './components/Ondemand'
import { Virtual } from './components/Virtual'

const BottomPartCard = ({ children }: { children: ReactNode }) => (
  <>{children}</>
)

export default { BottomPartCard, Ondemand, Virtual }
